import key from "keymaster";
import Turbolinks from "turbolinks";

$(document).on("turbolinks:load", () => {
  if (!$("body.admin_shipments").length) {
    return;
  }

  let shortcutExplanations = [
    ["?", "Show/hide this overview"],
    ["/", "Go to the search box"],
  ];

  function bindShortcuts(shortcuts, explanation, callback) {
    for (let shortcut of shortcuts) {
      shortcutExplanations.push([shortcut, explanation]);
      key(shortcut, (e) => {
        e.preventDefault();
        callback();
      });
    }
  }

  function makeUrl(section) {
    const shipmentId = $("#navigation-identifiers").data("shipmentId");
    if (shipmentId === undefined) {
      return "";
    } else {
      return `/admin/shipments/${shipmentId}/${section}`;
    }
  }

  function visitSection(section) {
    const url = makeUrl(section);
    if (url != "" && url != window.location.pathname) {
      Turbolinks.visit(url);
    }
  }

  bindShortcuts(["ctrl+shift+a"], "Select all revenue items", () => {
    $("input.revenue-item-checkbox").click();
  });

  bindShortcuts(["ctrl+shift+c"], "Private chat", () => {
    visitSection("private_chat");
  });

  bindShortcuts(["ctrl+shift+d"], "Details", () => visitSection(""));

  bindShortcuts(["ctrl+shift+e"], "Edit", () => visitSection("edit"));

  bindShortcuts(["ctrl+shift+f"], "Finances", () => visitSection("finances"));

  bindShortcuts(["ctrl+shift+h"], "History", () => visitSection("history"));

  bindShortcuts(["ctrl+shift+i"], "Log in", () => {
    let href = $("a#login-link").attr("href");
    window.open(href, "_blank");
  });

  bindShortcuts(["ctrl+shift+l"], "Containers", () => visitSection("containers"));

  bindShortcuts(["ctrl+shift+1"], "Documents", () => visitSection("documents"));

  bindShortcuts(["ctrl+shift+q"], "Export", () => visitSection("export"));

  bindShortcuts(["ctrl+shift+s"], "SOP (or `Save` when editing)", () => visitSection("sop"));

  bindShortcuts(["ctrl+shift+y"], "Tasks", () => visitSection("tasks"));

  if ($("body.edit").length) {
    key("ctrl+shift+s", (e) => {
      e.preventDefault();
      $("form:first").submit();
    });
  }

  function createHotkeyTable() {
    let html = "";

    for (let shortcutExplanation of shortcutExplanations) {
      html += `<tr><td>${shortcutExplanation[0]}</td><td>${shortcutExplanation[1]}</td></tr>`;
    }

    let modal = `
      <div id="hotkey-table" class="modal fade" tabindex="-1">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Keyboard shortcuts</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <table class="table table-sm table-responsive-sm">
              <thead><tr><th>Combination</th><th>Action></th></tr></thead>
              <tbody>${html}</tbody>
              </table>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    `;

    $("body").append(modal);
  }

  createHotkeyTable();
});

$(document).on("click", "#hotkey-table .close", () => {
  $("#hotkey-table").modal("toggle");
});

$(document).on("click", "button.hotkey-toggle", () => {
  $("#hotkey-table").modal("show");
});

$(document).on("keydown", (e) => {
  if (e.key == "?" && e.target.tagName == "BODY") {
    $("#hotkey-table").modal("toggle");
  }
});
